/* import __COLOCATED_TEMPLATE__ from './handover-config.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type FinVoiceNumberConfiguration from 'embercom/models/fin-voice/number-configuration';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: any;
    numberConfiguration?: FinVoiceNumberConfiguration;
    updateHandoverConfig: (goodbyeMessage: string) => Promise<void>;
  };
}

export default class HandoverConfig extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked goodbyeMessage = this.savedGoodbyeMessage ?? this.defaultGoodbyeMessage;

  get numberConfiguration() {
    return this.args.numberConfiguration;
  }

  get defaultGoodbyeMessage(): string {
    return this.intl.t(
      'operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.goodbye-message-placeholder-workflow',
    );
  }

  get savedGoodbyeMessage(): string | undefined {
    return this.numberConfiguration?.ivrGoodbyeMessage;
  }

  get hasChanges() {
    return this.goodbyeMessage !== (this.savedGoodbyeMessage ?? this.defaultGoodbyeMessage);
  }

  get savingDisabled() {
    return !this.hasChanges;
  }

  @action
  onGoodbyeMessageInput(value: string) {
    this.goodbyeMessage = value;
  }

  @action
  resetGoodbyeMessage() {
    this.goodbyeMessage = this.savedGoodbyeMessage ?? this.defaultGoodbyeMessage;
  }

  @action
  async saveGoodbyeMessage() {
    await this.args.updateHandoverConfig(this.goodbyeMessage);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinVoice::HandoverConfig': typeof HandoverConfig;
  }
}
